export const LEAGUE_TYPE = { PUBLIC: 1, PRIVATE: 2 }

export const deleteLeagueMessage = (name, count = 0) =>
  `Delete ${name}? This deletes the league for all ${count} member${count === 1 ? '' : 's'}. ` +
  'Their fantasy teams, game points and other league memberships remain unchanged.'

// "12" with no limit, "12 / 50" with one.
export const leagueMembersLabel = (league) => {
  const count = league?.members_count ?? 0
  return league?.member_limit != null ? `${count} / ${league.member_limit}` : `${count}`
}

// Team ids of a league from either the listing ("3,7") or the detail ([{ id }]).
export const leagueTeamIds = (league) => {
  if (Array.isArray(league?.teams)) return league.teams.map((team) => Number(team.id))
  if (league?.team_ids) return String(league.team_ids).split(',').map(Number)
  return []
}
